import { Skeleton } from "@shared/src/components/ui/skeleton";

/**
 * Skeleton placeholder for the Quick-Trade form while options / data are loading.
 * The real form is a centred single-column layout (max-width 32rem) with
 * several stacked blocks. We mimic that structure so the page doesn’t shift
 * when the actual content arrives.
 */
export function QuickTradeSkeleton() {
  return (
    <div className="flex flex-col items-center w-full px-4 py-10">
      {/* Header */}
      <header className="w-full max-w-lg mb-8 space-y-3">
        <Skeleton className="h-8 w-48 mx-auto" /> {/* "P2P Quick Trade" */}
        <Skeleton className="h-4 w-3/4 mx-auto" /> {/* description */}
      </header>

      {/* Form */}
      <div className="w-full max-w-lg space-y-8">
        {/* Trade type switch */}
        <div className="w-fit mx-auto">
          <Skeleton className="h-12 w-36 rounded-full" />
        </div>

        {/* Amount / network / token input */}
        <Skeleton className="h-[120px] w-full rounded-5xl" />

        {/* Currency & payment selectors */}
        <div className="flex gap-4">
          <Skeleton className="h-12 w-1/3 rounded-xl flex-1" />
          {/* Currency */}
          <Skeleton className="h-12 w-2/3 rounded-xl flex-[2]" />
          {/* Payment method */}
        </div>

        {/* Secondary amount input */}
        <Skeleton className="h-[120px] w-full rounded-5xl" />

        {/* Fee / gas info */}
        <Skeleton className="h-8 w-48 mx-auto" />

        {/* Rate adjuster */}
        <Skeleton className="h-[100px] w-full rounded-3xl" />

        {/* Action button */}
        <Skeleton className="h-14 w-full rounded-full" />
      </div>
    </div>
  );
}
